import { createContext, useCallback, useMemo, useState, type ReactNode } from "react";

export type BillingDataContextValue = {
  version: number;
  refresh: () => Promise<void>;
};

export const BillingDataContext = createContext<BillingDataContextValue>({
  version: 0,
  refresh: async () => {},
});

export function BillingDataContextProvider({
  version,
  refresh,
  children,
}: {
  version: number;
  refresh: () => Promise<void>;
  children: ReactNode;
}) {
  const value = useMemo(() => ({ version, refresh }), [version, refresh]);
  return <BillingDataContext.Provider value={value}>{children}</BillingDataContext.Provider>;
}

export function useBillingDataVersion() {
  const [version, setVersion] = useState(0);
  const bump = useCallback(() => setVersion((v) => v + 1), []);
  return { version, bump };
}
